import { connect } from 'react-redux';

import Share, { StateProps } from './share';
import { getPageMeta } from 'client/ducks/app/selectors';
import { State } from 'client/store';

function mapStateToProps(state: State): StateProps {
    return { pageMeta: getPageMeta(state) };
}

export default connect<StateProps>(mapStateToProps)(Share);
